import * as core from '../../../../../../../core'
import * as anomaly from '../anomaly'

export const RESOURCE = {
  payload: {
    description: 'Floor Plan is Incorrect',
    enumId: core.dms.models.Enum.Id.from({
      partialId: anomaly.RESOURCE.payload.partialId,
    }),
    id: 'INCORRECT_FLOOR_PLAN',
    name: 'Incorrect Floor Plan',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
